import { Radio, Typography } from 'antd'
import type { NavigateAction } from 'react-big-calendar'

interface CustomToolbarProps {
    label: string
    onNavigate: (action: NavigateAction) => void
}

export const CustomRBCToolbar = (props: CustomToolbarProps) => {
    const { onNavigate, label } = props

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px' }}>
            <Radio.Group>
                <Radio.Button value="back" onClick={() => onNavigate('PREV')}>
                    Назад
                </Radio.Button>
                <Radio.Button value="forward" onClick={() => onNavigate('NEXT')}>
                    Вперед
                </Radio.Button>
            </Radio.Group>
            <Typography.Text strong>{label}</Typography.Text>
            <div />
        </div>
    )
}
